module.exports = __webpack_public_path__ + "static_pc/img/demo1.48a23127.png";